module.exports = __webpack_public_path__ + "img/seller.dcf92550.png";